import arrify from 'arrify'

export default (args, keys) => {
  if (typeof args !== 'object') {
    throw new TypeError(`Expected args to be an object, got ${typeof args}`)
  }

  arrify(keys).forEach(key => {
    if (typeof args[key] !== 'string' && typeof args[key] !== 'number') {
      throw new TypeError(
        `Expected ${key} to be string or number, got ${typeof args[key]}`
      )
    }
  })
}
